<div class="mb-4">
  <div style="overflow: hidden">
    {{message}}
  </div>
  @if (showCopyButton) {
    <div>
      <button pButton *ngxClipboardIfSupported ngxClipboard [cbContent]="message" (cbOnSuccess)="onCopy()">Copy</button>
      @if (copied()) {
        <span class="ms-1">Copied to clipboard!</span>
      }
    </div>
  }
</div>

<div class="p-dialog-footer">


  @if (showCancelButton) {
    <button pButton type="button" (click)="modalRef.close('canceled')"
    [label]="cancelButtonText"></button>
  }
  @if (showConfirmButton) {
    <button pButton type="button" [severity]="confirmButtonSeverity"
    (click)="modalRef.close('confirmed')" [label]="confirmButtonText"></button>
  }
</div>